import { useState, useEffect } from "react";
import { GetSearchData } from "../CRUDPage/FetchData";
import AddPDF from "../CRUDPage/AddPDF";

const InfoList=['VA', 'VACC', 'S', 'C', 'A', 'AL', 'ACD', 'LT', 'CCT', 'WTW', 'Pupil', 'Kappa', 'angle', 'ART', 'CD', 'VFI', 'MD30', 'MD24', 'MD24c', 'MD10', 'CAT', 'iop_records'];
const testText = {VA:"VA", VACC:"VACC", S:"S", C:"C", A:"A", IOP:"IOP", AL:"AL", ACD:"ACD", LT:"LT", CCT:"CCT", WTW:"WTW", Pupil:"Pupil", Kappa:"Kappa", angle:"Kappa軸度", ART:"Average RNFL Thickness", CD:"Average C/D Ratio", MD:"MD30-2", CAT:"Cube Thickness Average"};


function ListAllRecord({patientData}){
    const [InfoContent, setInfoContent] = useState([]);
    const [index, setIndex] = useState(0);

    let gettingData = GetSearchData("eye_record/"+patientData.client_data_record_id);

    useEffect(() => {
        try{
            if(typeof gettingData === "object" && gettingData.hasOwnProperty("message")){
                console.log("error:",gettingData)
            }
            else if(typeof gettingData === "object" && !gettingData.hasOwnProperty("message")){
                console.log(gettingData)
                setInfoContent(gettingData);
            }
        }
        catch(error){
            console.log("error:", error)
        }
    }, [gettingData])


    return(
        <div className="text-xl">
            {InfoContent.length===0 ? <div>loading...</div> : 
            <>
                <label htmlFor="date"></label>
                <select name="date" onChange={(event) => setIndex(event.target.value-1)}>
                    {
                        InfoContent.map((record, index) => (
                            <option value={index+1}>{InfoContent[index].test_date}</option>
                        ))
                    }
                </select>
                <div className="flex overflow-auto justify-center text-xl">
                    <table className="w-1/2">
                        <thead>
                            <tr >
                                <td className="w-1/3" >測驗項目</td>
                                <td className="p-4 py-2 w-1/3">OD</td>
                                <td className="p-4 py-2 w-1/3">OS</td>
                            </tr>
                        </thead>
                        <tbody className=" divide-y divide-black-200">
                            {
                                InfoList.map((item) => (
                                    item !== "iop_records" ? 
                                    (<tr >
                                        <td className="w-1/3">{testText[item] ? testText[item] : item}</td>
                                        <td className="p-4 py-2 w-1/3">{InfoContent[index][item+"_OD"]}</td>
                                        <td className="p-4 py-2 w-1/3">{InfoContent[index][item+"_OS"]}</td>
                                    </tr>) : 
                                    (<>
                                        <tr >
                                            <td>IOP</td>
                                        </tr>
                                        {
                                            InfoContent[index].iop_records.length===0 ? (<td></td>) : (
                                            <>
                                                <tr >
                                                    <td className="px-12 py-2 w-1/4">測驗時間</td>
                                                    <td className="px-12 py-2 w-1/4">OD</td>
                                                    <td className="px-12 py-2 w-1/4">OS</td>
                                                </tr>
                                                {InfoContent[index].iop_records.map((record) => (
                                                    <tr >
                                                        <td className="px-12 py-2 w-1/4">{record.test_time}</td>
                                                        <td className="px-12 py-2 w-1/4">{record["IOP_OD"]}</td>
                                                        <td className="px-12 py-2 w-1/4">{record["IOP_OS"]}</td>
                                                    </tr>
                                                ))}
                                            </>
                                            )
                                        }
                                    </>
                                    )
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                <table>
                    <AddPDF record_id={InfoContent[index].record_id} onlyForRead={true}></AddPDF>
                </table>
            </>
            }
        </div>
    )
}

export default ListAllRecord;